import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

export const TopLevelDomainsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction='ListTopLevelDomains' redirectTo='/'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path='add'
                element={
                    <AuthorizedRouteElement rbacAction='CreateTopLevelDomain' redirectTo='/top-level-domains'>
                        <AddPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path=':id'
                element={
                    <AuthorizedRouteElement rbacAction='GetTopLevelDomain' redirectTo='/top-level-domains'>
                        <EditPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
